import tablesApi from '../../api/tables-api';

const tables = {
    items: [],
    item: {},
    listSelectTables: [],
    popupNewTable: false,
    popupEditTable: false,
};

const mutations = {
    setItemsTables(state, payload) {
        state.items = payload.data;
    },
    setItemTable(state, payload) {
        state.item = payload;
    },
    setSelectTables(state, payload) {
        state.listSelectTables = payload;
    },
    setpopupNewTable(state, payload) {
        state.popupNewTable = payload;
    },
    setpopupEditTable(state, payload) {
        state.popupEditTable = payload;
    },
};

const actions = {
    async refreshTables(context, { language, restaurant_id }) {
        if (!restaurant_id) {
            restaurant_id = this.getters.getCurrentRestaurant;
        }
        if (restaurant_id) {
            const res = await tablesApi.getAllByRestaurant(restaurant_id, language);
            context.commit('setItemsTables', res.data);
        }
    },
    async getListTables(context, { language, restaurants }) {
        if (!restaurants) {
            restaurants = [this.getters.getCurrentRestaurant];
        }
        if (restaurants) {
            const res = await tablesApi.getListSelect(restaurants, language);
            context.commit('setSelectTables', res.data);
        }
    },
    async getTable(context, { id, language }) {
        context.commit('setItemTable', {});
        context.commit('loading', true);
        context.commit('setItemTable', {});
        tablesApi.getOne(id, language).then(
            (response) => {
                context.commit('setItemTable', response.data.data);
                context.commit('loading', false);
            },
            (error) => {
                context.commit('loading', false);
            },
        );
    },
    createTable({ commit, dispatch }, { table, language }) {
        commit('loading', true);
        tablesApi.create(table, language).then(
            (response) => {
                dispatch('refreshTables', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'table.MesaCreada' });
                commit('setpopupNewTable', false);
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('loading', false);
                commit('notifications', { title: 'table.NotMesaCreada', color: 'danger' });
                commit('showNotifications', true);
            },
        );
    },
    deleteTable({ commit, dispatch }, id) {
        commit('loading', true);
        tablesApi.delete(id).then(
            (response) => {
                dispatch('refreshTables', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'table.MesaEliminada' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'table.NotMesaEliminada', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
    activeTable({ commit, dispatch }, id) {
        commit('loading', true);
        tablesApi.active(id).then(
            (response) => {
                dispatch('refreshTables', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'table.MesaActivada' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'table.NotMesaActivada', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
    deactiveTable({ commit, dispatch }, id) {
        commit('loading', true);
        tablesApi.deactive(id).then(
            (response) => {
                dispatch('refreshTables', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'table.MesaDesactivada' });
                commit('loading', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'table.NotMesaDesactivada', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
    editTable({ commit, dispatch }, { id, table, language }) {
        commit('loading', true);
        tablesApi.edit(id, table, language).then(
            (response) => {
                dispatch('refreshTables', { language: this.getters.getCurrentLanguage });
                commit('notifications', { title: 'table.MesaEditada' });
                commit('loading', false);
                commit('setpopupEditTable', false);
                commit('showNotifications', true);
            },
            (error) => {
                commit('notifications', { title: 'table.NotMesaEditada', color: 'danger' });
                commit('loading', false);
                commit('showNotifications', true);
            },
        );
    },
};

const getters = {
    getTable: (state) => state.item,
    getTables: (state) => state.items,
    getSelectTables: (state) => state.listSelectTables,
    getpopupNewTable: (state) => state.popupNewTable,
    getpopupEditTable: (state) => state.popupEditTable,
};

export default {
    state: tables,
    mutations,
    actions,
    getters,
};